import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { loginMFALoaderConfig } from '../constants/loader';
import { AuthService, CargoL, InlineResponse200, UserService } from '../../../api';
import { PersonalizationsService } from '../../../base/services/personalizations/personalizations.service';
import { Environment } from '../../../models/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoadingMfaService {

  eventMessage: EventEmitter<string> = new EventEmitter<string>();

  environment: Environment;
  response: InlineResponse200;
  notifMessage: string = '';
  showError: boolean = false;

  constructor(private _auth: AuthService,
    private _personalization: PersonalizationsService,
    private _router: Router
    ) {
    this.environment = this._personalization.sendEnv
   }

  isActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loginConfig: BehaviorSubject<Record<'text' | 'icon', string> | null> = new BehaviorSubject(null);

  setLoader(state: boolean): void {
    this.isActive.next(state);
  }

  public getLoginTypeProps(typeLogin: string): void {
    const config = {
      text: loginMFALoaderConfig[typeLogin]?.text,
      icon: loginMFALoaderConfig[typeLogin]?.icon,
    }
    this.loginConfig.next(config);
  }

  async validateUser(preToken: string, transactionId: string): Promise<InlineResponse200> {
    try {
      this.response = await this._auth.validateMfaTokenPost('password', this.environment.appid, transactionId, preToken).toPromise();
      if(this.response){
        return this.response;
      }
    }
    catch(e){
      this.notifMessage = e.error.error_description;
      this.showError = true;
      this._router.navigate(['tasks/pending'])
    }
  }

}
